import type { SxProps, Theme } from '@mui/material/styles'

export const aggregateTableRowSx: SxProps<Theme> = {
    '& .MuiTableCell-root': {
        verticalAlign: 'top',
        py: 0.5,
        px: 1,
    },
}

export const aggregateTableCellSx: SxProps<Theme> = {
    position: 'relative',
    height: '40px',
    pr: '40px',
    '& .aggregate': {
        position: 'absolute',
        top: '4px',
        right: '8px',
    },
    '& .aggr-result': {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        width: 'min-content',
        minWidth: '100%',
        gap: 0.5,
    },
    '& .aggr-result > *': {
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
    },
}
